// デプロイ後に古いタブを開きっぱなしのユーザーが route 遷移すると、
// 参照している hashed chunk が既に消えていて vite の preload が落ちる。
// 一度だけ自動 reload して新しいシェルを取りに行く。
//
// cooldown 内に再発した場合は reload しても直っていない（CDN の伝播待ち / 真の壊れ等）。
// 無限 reload を避け、Sentry に「自動回復不能」として error で通知する。
//
// preventDefault() を呼ばないと vite の preload ヘルパが元エラーを再スローし
// （`if (!e.defaultPrevented) throw err`）、reload で復旧済みでも Sentry にノイズが上がる。

import * as Sentry from '@sentry/vue'

const CHUNK_RELOAD_TS_KEY = '__chunk_reload_ts__'
const CHUNK_RELOAD_COOLDOWN_MS = 60_000

export function setupChunkReloadRecovery(): void {
  // preventDefault すると vite は同じ import の残りの失敗（CSS ごと・module 本体）も dispatch し続ける。
  // reload を発行済みのページでそれらを cooldown 内の再発と誤認しないよう、ページ単位で握りつぶす。
  let reloading = false
  window.addEventListener('vite:preloadError', (event) => {
    if (reloading) {
      event.preventDefault()
      return
    }
    let last = 0
    try {
      last = Number(sessionStorage.getItem(CHUNK_RELOAD_TS_KEY) ?? '0')
    } catch {
      // iOS Safari private mode 等で storage が落ちる環境では諦める
      // （reload しても last を記録できないので、防げない無限 reload を避ける）。
      return
    }
    if (Date.now() - last < CHUNK_RELOAD_COOLDOWN_MS) {
      event.preventDefault()
      Sentry.captureMessage('chunk preload errored again within reload cooldown', {
        level: 'error',
        extra: { sinceLastReloadMs: Date.now() - last },
      })
      return
    }
    try {
      sessionStorage.setItem(CHUNK_RELOAD_TS_KEY, Date.now().toString())
    } catch {
      // Storage blocked (e.g. iOS Safari private mode); Do nothing in this case.
      return
    }
    reloading = true
    event.preventDefault()
    window.location.reload()
  })
}
